import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import API from "../../api/api";
import "../../style/addPlan.css";

const AddPlan = () => {

  const navigate = useNavigate();

  const [form, setForm] = useState({
    name: "",
    credits: "",
    price: "",
    description: "",
    features: [""],
    isPopular: false
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    setForm({
      ...form,
      [name]: type === "checkbox" ? checked : value
    });
  };

  // ===== FEATURES HANDLING =====
  const handleFeatureChange = (index, value) => {
    const updated = [...form.features];
    updated[index] = value;

    setForm({
      ...form,
      features: updated
    });
  };

  const addFeature = () => {
    setForm({
      ...form,
      features: [...form.features, ""]
    });
  };

  const removeFeature = (index) => {
    const updated = form.features.filter((_, i) => i !== index);

    setForm({
      ...form,
      features: updated
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {

      setLoading(true);

      await API.post("/admin/plans/add", {
        ...form,
        credits: Number(form.credits),
        price: Number(form.price),
        features: form.features.filter(f => f.trim() !== "")
      });

      alert("Plan created successfully");

      navigate("/admin/plans");

    } catch (err) {

      console.error("Add plan error:", err);
      alert(err.response?.data?.message || "Failed to add plan");

    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="add-plan-container">

        <button
          className="back-btn"
          onClick={() => navigate("/admin/plans")}
        >
          ← Back to Plans
        </button>


      <h2>Add Plan</h2>

      <form onSubmit={handleSubmit} className="plan-form">

        <input
          type="text"
          name="name"
          placeholder="Plan Name"
          value={form.name}
          onChange={handleChange}
          required
        />

        <input
          type="number"
          name="credits"
          placeholder="Credits"
          value={form.credits}
          onChange={handleChange}
          required
        />

        <input
          type="number"
          name="price"
          placeholder="Price"
          value={form.price}
          onChange={handleChange}
          required
        />

        <textarea
          name="description"
          placeholder="Description"
          value={form.description}
          onChange={handleChange}
        />

        {/* ===== FEATURES ===== */}
        <div className="features-section">

          <label>Features</label>

          {form.features.map((feature, index) => (
            <div key={index} className="feature-row">

              <input
                type="text"
                value={feature}
                placeholder={`Feature ${index + 1}`}
                onChange={(e) =>
                  handleFeatureChange(index, e.target.value)
                }
              />

              <button
                type="button"
                onClick={() => removeFeature(index)}
              >
                ❌
              </button>

            </div>
          ))}

          <button
            type="button"
            className="add-feature-btn"
            onClick={addFeature}
          >
            + Add Feature
          </button>

        </div>

        {/* ===== POPULAR ===== */}
        <label className="checkbox-row">
          <input
            type="checkbox"
            name="isPopular"
            checked={form.isPopular}
            onChange={handleChange}
          />
          Mark as Most Popular
        </label>

        <button type="submit" disabled={loading}>
          {loading ? "Creating..." : "Create Plan"}
        </button>

      </form>

    </div>
  );
};

export default AddPlan;